import { Component, OnInit } from '@angular/core';

import { filter, map, NEVER, Observable } from 'rxjs';

import { CmsArticle, CmsTarget } from '@fcom/core-api';
import { isPresent } from '@fcom/core/utils';
import { PromoTheme } from '@fcom/ui-components';
import { FragmentService } from '@fcom/common';

@Component({
  selector: 'fin-announcement-card',
  templateUrl: './announcement-card.component.html',
  styleUrls: ['./announcement-card.component.scss'],
  standalone: false,
})
export class AnnouncementCardComponent implements OnInit {
  readonly PromoTheme = PromoTheme;

  promoCta$: Observable<CmsTarget> = NEVER;
  promoData$: Observable<CmsArticle> = NEVER;

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    this.promoData$ = this.fragmentService.getFragment<CmsArticle>('LOYALTY.fragments.announcementCard.url');
    this.promoCta$ = this.promoData$.pipe(
      map((data) => data?.related[0]),
      filter(isPresent),
      map(
        (item) =>
          ({
            ...item.target,
            title: item.teaserTitle,
          }) as CmsTarget
      )
    );
  }
}
